import { Navigate } from "react-router-dom";
const Protected = ({ children }) => {
    let token = localStorage.getItem("access");
    if (token) {
	return children;
    }
    return <Navigate to="/login" replace />;
};
export default Protected;
